export default function Occupations() {
  let occupationList = [
    { value: "", label: "" },
    { value: "1", label: "Accountant" },
    { value: "2", label: "Actor" },
    { value: "3", label: "Actuary" },
    { value: "4", label: "Administrator" },
    { value: "5", label: "Administrator or Educational Office" },
    { value: "6", label: "Aerobics instructor" },
    { value: "7", label: "Aesthetician" },
    { value: "8", label: "Agricultural engineer or technician" },
    { value: "9", label: "Agricultural equipment operator" },
    { value: "10", label: "Agricultural inspector" },
    { value: "11", label: "Agricultural worker" },
    { value: "12", label: "Air Marshal" },
    { value: "13", label: "Air traffic controller" },
    { value: "14", label: "Aircraft mechanic and service technician" },
    { value: "15", label: "Aircraft pilot" },
    { value: "16", label: "Aircraft structure assembler" },
    { value: "17", label: "Ambulance driver" },
    { value: "19", label: "Amusement and recreation attendant" },
    { value: "20", label: "Animal breeder" },
    { value: "21", label: "Animal Control" },
    { value: "22", label: "Animal control worker" },
    { value: "23", label: "Animal scientist" },
    { value: "24", label: "Animal trainer" },
    { value: "25", label: "Animator" },
    { value: "26", label: "Announcer" },
    { value: "27", label: "Antenna installer and repairer" },
    { value: "28", label: "Anthropologist" },
    { value: "29", label: "Appraiser or estimator" },
    { value: "30", label: "Arbitrator, mediator, and conciliator" },
    { value: "31", label: "Arborist" },
    { value: "32", label: "Arcade employee" },
    { value: "33", label: "Archeologist" },
    { value: "34", label: "Architect" },
    { value: "35", label: "Archivist, Curator or Museum Technician" },
    { value: "36", label: "Armored Car Driver" },
    { value: "37", label: "Art director" },
    { value: "38", label: "Artist or related worker" },
    { value: "39", label: "Asbestos, Lead Hazardous materials worker" },
    { value: "40", label: "Asphalt, Paving equipment worker" },
    { value: "41", label: "Assembler and fabricator" },
    { value: "42", label: "Astronaut" },
    { value: "43", label: "Astronomer" },
    { value: "44", label: "Athletes and Sports Competitor" },
    { value: "45", label: "Athletic trainer" },
    { value: "46", label: "Audio and video equipment technician" },
    { value: "47", label: "Audio Visual Specialist" },
    { value: "48", label: "Audiologist" },
    { value: "49", label: "Auditor" },
    { value: "50", label: "Author" },
    { value: "51", label: "Auto Sales, New" },
    { value: "52", label: "Auto Sales, Used" },
    { value: "53", label: "Automobile stunt or speed testing driver" },
    { value: "54", label: "Automotive body painter or repairer" },
    { value: "55", label: "Automotive glass installer and repairer" },
    { value: "56", label: "Automotive service mechanic" },
    { value: "57", label: "Avionics technician" },
    { value: "58", label: "Baggage Handler" },
    { value: "59", label: "Baggage porter, bellhop, and concierge" },
    { value: "60", label: "Bail bondsman" },
    { value: "61", label: "Bailiff or jailer" },
    { value: "62", label: "Baker" },
    { value: "63", label: "Bar Manager, Doorman, or Bouncer" },
    { value: "64", label: "Barber, hairdresser, hairstylist" },
    { value: "65", label: "Bartender" },
    { value: "66", label: "Bicycle repairer" },
    { value: "67", label: "Bill and account collector" },
    { value: "68", label: "BioChemist" },
    { value: "69", label: "Biomedical engineer" },
    { value: "70", label: "BioPhysicist" },
    { value: "71", label: "Boilermaker" },
    { value: "72", label: "Bomb Disposal Crew" },
    { value: "73", label: "Bookkeeper" },
    { value: "74", label: "Border Patrol" },
    { value: "75", label: "Brickmason or Stonemason" },
    { value: "76", label: "Bridge Construction worker" },
    { value: "77", label: "Building maintenance" },
    { value: "78", label: "Bus and truck mechanic" },
    { value: "79", label: "Bus driver, school or special client" },
    { value: "80", label: "Bus driver, transit and intercity" },
    { value: "81", label: "Business manager" },
    { value: "82", label: "Butcher and meat cutter" },
    { value: "83", label: "Cabinetmaker and bench carpenter" },
    { value: "84", label: "Camera equipment repairer" },
    { value: "85", label: "Camera operator, television or video" },
    { value: "86", label: "Captain or Crew of water vessel" },
    { value: "87", label: "Car Wash Worker" },
    { value: "88", label: "Cardiovascular technologist or technician" },
    { value: "89", label: "Carpenter" },
    { value: "90", label: "Carpet, tile, floor installer" },
    { value: "91", label: "Cartographer" },
    { value: "92", label: "Cashier" },
    { value: "93", label: "Casino, Gaming booth cashier" },
    { value: "94", label: "Casino, Gaming cage worker" },
    { value: "95", label: "Casino, Gaming Security guard" },
    { value: "96", label: "Caterer" },
    { value: "97", label: "Ceiling tile installer" },
    { value: "98", label: "Cement mason, concrete worker" },
    { value: "99", label: "Cement or dump truck driver" },
    { value: "100", label: "Chef" },
    { value: "101", label: "Chemical & Biological Weaponary Testing" },
    { value: "102", label: "Chemical engineer or technician" },
    { value: "103", label: "Chemical equipment operator and tender" },
    { value: "104", label: "Chemical plant and system operator" },
    { value: "105", label: "Chemist" },
    { value: "106", label: "Chief executive" },
    { value: "107", label: "Childcare worker" },
    { value: "108", label: "Chiropractor" },
    { value: "109", label: "Choreographer" },
    { value: "110", label: "Circus or carnival performer or worker" },
    { value: "111", label: "Civil engineer or technician" },
    { value: "112", label: "Claims adjuster, examiner" },
    { value: "113", label: "Clerk" },
    { value: "114", label: "Club pro, golf, tennis, swimming, fitness" },
    { value: "115", label: "Coach, Umpire, or Related worker" },
    { value: "116", label: "Coal Miner" },
    { value: "117", label: "Coin or vending machine svc or repair" },
    { value: "118", label: "Commercial and industrial designer" },
    { value: "119", label: "Commercial Fisherman" },
    { value: "120", label: "Commercial Mover or Packer" },
    { value: "121", label: "Commercial or marine diver" },
    { value: "122", label: "Commercial pilot" },
    { value: "123", label: "Commodities Broker or Day Trader" },
    { value: "124", label: "Communications equipment operator" },
    { value: "125", label: "Community health worker" },
    { value: "126", label: "Compliance officer" },
    { value: "127", label: "Composer" },
    { value: "128", label: "Computer control programmer and operator" },
    { value: "129", label: "Computer hardware engineer" },
    { value: "130", label: "Computer programmer" },
    { value: "131", label: "Computer support specialist" },
    { value: "132", label: "Computer, ATM or business maching repair" },
    { value: "133", label: "Conservation scientist" },
    { value: "134", label: "Construction  worker" },
    { value: "135", label: "Construction equipment operator" },
    { value: "136", label: "Construction laborer" },
    { value: "137", label: "Construction or building inspector" },
    { value: "138", label: "Consultant" },
    { value: "139", label: "Control and valve installer and repairer" },
    { value: "140", label: "Convenience Store worker" },
    { value: "141", label: "Cook" },
    { value: "142", label: "Cook, fast food" },
    { value: "143", label: "Cook, private household" },
    { value: "144", label: "Coroner" },
    { value: "145", label: "Correctional officer" },
    { value: "146", label: "Counselor" },
    { value: "147", label: "Countertop worker; laminates or wood" },
    { value: "148", label: "Countertop worker; stone or cement" },
    { value: "149", label: "Court reporter" },
    { value: "150", label: "Credit counselor" },
    { value: "151", label: "Crossing guards" },
    { value: "152", label: "Customer service representative" },
    { value: "153", label: "Cutting worker" },
    { value: "154", label: "Dancer" },
    { value: "155", label: "Data entry" },
    { value: "156", label: "Database or Network administrator" },
    { value: "157", label: "Day Care or Pre School  in residence" },
    { value: "158", label: "Day Care or Pre School not in residence" },
    { value: "159", label: "Demonstrator and product promoter" },
    { value: "160", label: "Dental assistant" },
    { value: "161", label: "Dental hygienist" },
    { value: "162", label: "Dental laboratory technician" },
    { value: "163", label: "Dentist" },
    { value: "164", label: "Derrick or driller oil, gas, or mining" },
    { value: "165", label: "Designer" },
    { value: "166", label: "Detective and criminal investigator" },
    { value: "167", label: "Dietitian or nutritionist" },
    { value: "169", label: "Dishwasher" },
    { value: "170", label: "Dispatcher" },
    { value: "171", label: "Dock worker or Longshoreman" },
    { value: "172", label: "Door-to-door sales, news or street vendor" },
    { value: "173", label: "Drafter" },
    { value: "174", label: "Driver/sales worker" },
    { value: "175", label: "Dry Cleaning Worker" },
    { value: "176", label: "Drywall installer" },
    { value: "177", label: "Earth driller, except oil and gas" },
    { value: "178", label: "Economist" },
    { value: "179", label: "Editor" },
    { value: "180", label: "Electric motor repairer" },
    { value: "181", label: "Electrical mechanic or repairer" },
    { value: "182", label: "Electrical or Overhead power-line worker" },
    { value: "183", label: "Electrician" },
    { value: "184", label: "Elevator installer and repairer" },
    { value: "185", label: "Embalmer" },
    { value: "186", label: "Emergency management director" },
    { value: "187", label: "Emergency med technician or paramedic" },
    { value: "188", label: "Engine and other machine assembler" },
    { value: "189", label: "Engineer or engineering technician" },
    { value: "190", label: "Entertainer or performer" },
    { value: "191", label: "Environmental engineer" },
    { value: "192", label: "Environmental scientist or geoscientist" },
    { value: "193", label: "Epidemiologist" },
    { value: "194", label: "Equipment assembler" },
    { value: "195", label: "Etcher and engraver" },
    { value: "196", label: "Event planner" },
    { value: "197", label: "Exercise physiologist" },
    { value: "198", label: "Explosives blaster or handler" },
    { value: "199", label: "Extraction worker" },
    { value: "200", label: "Fabric and apparel patternmaker" },
    { value: "201", label: "Fabric mender, except garment" },
    { value: "202", label: "Factory worker" },
    { value: "203", label: "Farm equipment mechanic or technician" },
    { value: "204", label: "Farm Labor" },
    { value: "205", label: "Farm or ranch worker, unskilled" },
    { value: "206", label: "Farmer" },
    { value: "207", label: "Fashion designer" },
    { value: "208", label: "Fast food  worker or busboy" },
    { value: "209", label: "Fence erector" },
    { value: "210", label: "Fiberglass laminator and fabricator" },
    { value: "211", label: "Film and video editor" },
    { value: "212", label: "Financial analyst" },
    { value: "213", label: "Financial Service Agent" },
    { value: "214", label: "Fire inspector" },
    { value: "215", label: "Firefighter" },
    { value: "216", label: "Fitness or Personal Trainer" },
    { value: "217", label: "Flagpole or steeplejack workers" },
    { value: "218", label: "Flight attendant" },
    { value: "219", label: "Flight engineer" },
    { value: "220", label: "Floor sander and finisher" },
    { value: "221", label: "Floral designer or florist" },
    { value: "222", label: "Food or beverage server" },
    { value: "223", label: "Food preparation worker" },
    { value: "224", label: "Food scientist and technologist" },
    { value: "225", label: "Foreman" },
    { value: "226", label: "Forensic science technician" },
    { value: "227", label: "Forest ranger or conservation worker" },
    { value: "228", label: "Forester or forest technician" },
    { value: "229", label: "Forklift Driver" },
    { value: "230", label: "Foundry mold and coremaker" },
    { value: "231", label: "Fundraiser" },
    { value: "232", label: "Funeral service worker" },
    { value: "233", label: "Furnace, kiln operator" },
    { value: "234", label: "Furniture finisher" },
    { value: "235", label: "Garbage Route Worker" },
    { value: "236", label: "Garbage Truck Driver" },
    { value: "237", label: "Gas compressor or gas pumper" },
    { value: "238", label: "Gas plant operator" },
    { value: "239", label: "Genetic Counselor" },
    { value: "240", label: "Geographer" },
    { value: "241", label: "Geological and petroleum technician" },
    { value: "242", label: "Geologist" },
    { value: "243", label: "Glass Installer or Glazier, Commercial" },
    { value: "244", label: "Glass Installer or Glazier, Residential" },
    { value: "245", label: "Graphic designer" },
    { value: "246", label: "Grounds maintenance worker" },
    { value: "247", label: "Groundskeeping worker" },
    { value: "248", label: "Health and safety engineer" },
    { value: "249", label: "Hearing aid specialist" },
    { value: "250", label: "Heating, air conditioning, (HVAC) worker" },
    { value: "251", label: "Heavy Equipment Operator" },
    { value: "252", label: "Heavy vehicle or equipment service" },
    { value: "253", label: "Helper, construction trades" },
    { value: "254", label: "Highway maintenance worker or flagman" },
    { value: "255", label: "Historian" },
    { value: "256", label: "Hoist and winch operator" },
    { value: "257", label: "Home appliance repairer" },
    { value: "258", label: "Home entertainment installer and repairer" },
    { value: "259", label: "Home health care provider or aide" },
    { value: "260", label: "Host, hostess, maitre'd" },
    { value: "262", label: "Human resources worker" },
    { value: "263", label: "Humane Shelter worker" },
    { value: "264", label: "Industrial engineer and technician" },
    { value: "265", label: "Industrial machinery mechanic" },
    { value: "267", label: "Information Technologist" },
    { value: "268", label: "Inspector, Tester" },
    { value: "269", label: "Insulation worker" },
    { value: "270", label: "Insurance Sales Agent" },
    { value: "271", label: "Insurance underwriter" },
    { value: "272", label: "Interior designer" },
    { value: "273", label: "Interpreter or translator" },
    { value: "274", label: "Ironworker" },
    { value: "275", label: "Janitor or cleaner" },
    { value: "276", label: "Jeweler and precious stone worker" },
    { value: "277", label: "Judge, magistrate judge or adjudicator" },
    { value: "278", label: "Judicial law clerk" },
    { value: "279", label: "Junk dealer" },
    { value: "280", label: "Lab Technician" },
    { value: "281", label: "Landscaper" },
    { value: "282", label: "Laundry or Laundromat worker" },
    { value: "283", label: "Law enforcement Office worker" },
    { value: "284", label: "Lawyer or Attorney" },
    { value: "285", label: "Legislator or elected official" },
    { value: "286", label: "Librarian" },
    { value: "287", label: "Library technician" },
    { value: "288", label: "Licensed practical nurse (LPN)" },
    { value: "289", label: "Licensed vocational nurse (LVN)" },
    { value: "290", label: "Lifeguard, ski patrol, or other" },
    { value: "291", label: "Loan officer" },
    { value: "292", label: "Locker,coat or dressing room attendant" },
    { value: "293", label: "Locksmith and safe repairer" },
    { value: "294", label: "Locomotive engineer and operator" },
    { value: "295", label: "Logging equipment operator" },
    { value: "296", label: "Logging hauler or worker" },
    { value: "297", label: "Machine tool setter, operator" },
    { value: "298", label: "Machinist" },
    { value: "299", label: "Maid, housekeeper, cleaner" },
    { value: "300", label: "Maintenance worker, machinery" },
    { value: "301", label: "Makeup artist, theatrical and performance" },
    { value: "302", label: "Manager" },
    { value: "303", label: "Manicurist and pedicurist" },
    { value: "304", label: "Manufactured or mobile bldg installer" },
    { value: "305", label: "Marine engineer and naval architect" },
    { value: "306", label: "Masseuse (Spa)" },
    { value: "307", label: "Meat, poultry, and fish trimmer" },
    { value: "308", label: "Mechanical door repairer" },
    { value: "309", label: "Mechanical engineer or technician" },
    { value: "310", label: "Media and communication worker" },
    { value: "311", label: "Medical appliance technician" },
    { value: "312", label: "Medical assistant" },
    { value: "313", label: "Medical equipment preparer" },
    { value: "314", label: "Medical equipment repairer" },
    { value: "315", label: "Medical Massage therapist (Not Spa)" },
    { value: "316", label: "Medical records technician" },
    { value: "317", label: "Medical scientist" },
    { value: "318", label: "Medical transcriptionist" },
    { value: "319", label: "Medical, dental, laboratory technician" },
    { value: "320", label: "Metal furnace operator" },
    { value: "321", label: "Meter reader, utilities" },
    { value: "322", label: "Microbiologist" },
    { value: "323", label: "Midwife" },
    { value: "324", label: "Migrant Worker" },
    { value: "325", label: "Military" },
    { value: "326", label: "Milling and planing machine operator" },
    { value: "327", label: "Millwright" },
    { value: "328", label: "Mining engineer mining safety engineer" },
    { value: "329", label: "Mining machine operator" },
    { value: "330", label: "Mining roof bolter" },
    { value: "331", label: "Minister, Preacher, or Priest" },
    { value: "333", label: "Miscellaneous sales and related worker" },
    { value: "334", label: "Missionary" },
    { value: "335", label: "Mobile heavy equipment mechanic" },
    { value: "336", label: "Model" },
    { value: "337", label: "Mortician, undertaker or funeral director" },
    { value: "338", label: "Motorboat mechanic and service technician" },
    { value: "339", label: "Motorboat operator" },
    { value: "340", label: "Motorcycle mechanic" },
    { value: "341", label: "MRI or Xray Technician" },
    { value: "342", label: "Music director" },
    { value: "343", label: "Musical instrument repairer and tuner" },
    { value: "344", label: "Musician or singer" },
    { value: "345", label: "Nanny" },
    { value: "346", label: "News analyst" },
    { value: "347", label: "Nuclear engineer or technician" },
    { value: "348", label: "Nuclear medicine technologist" },
    { value: "349", label: "Nuclear power reactor operator or worker" },
    { value: "350", label: "Nurse anesthetist" },
    { value: "351", label: "Nurse practitioner" },
    { value: "352", label: "Nursery or greenhouse worker" },
    { value: "353", label: "Nursing assistant" },
    { value: "354", label: "Nursing, psychiatric" },
    { value: "355", label: "Occupational therapist" },
    { value: "356", label: "Office and administrative support worker" },
    { value: "357", label: "Office machine operator, except computer" },
    { value: "358", label: "Offshore Worker" },
    { value: "359", label: "Oil, Gas, or Mining occupation" },
    { value: "360", label: "Ophthalmic laboratory technician" },
    { value: "361", label: "Ophthalmic medical technician" },
    { value: "362", label: "Optician, dispensing" },
    { value: "363", label: "Optometrist" },
    { value: "364", label: "Oral and maxillofacial surgeon" },
    { value: "365", label: "Orderly" },
    { value: "366", label: "Orthodontist" },
    { value: "367", label: "Orthotist or prosthetist" },
    { value: "368", label: "Information security analyst" },
    { value: "369", label: "Outdoor power mechanic" },
    { value: "370", label: "Packer and packager, hand" },
    { value: "371", label: "Painter, construction and maintenance" },
    { value: "372", label: "Painter, residential" },
    { value: "373", label: "Painting, coating, and decorating worker" },
    { value: "374", label: "Paralegal or legal assistant" },
    { value: "375", label: "Parking enforcement worker" },
    { value: "376", label: "Parking lot attendant" },
    { value: "377", label: "Patternmaker, metal and plastic" },
    { value: "378", label: "Patternmaker, wood" },
    { value: "379", label: "Pawnbroker" },
    { value: "380", label: "Pest control worker" },
    { value: "381", label: "Pharmacist" },
    { value: "382", label: "Pharmacy technician" },
    { value: "383", label: "Phlebotomist" },
    { value: "384", label: "Photographer or Portrait Photographer" },
    { value: "385", label: "Photographic process worker" },
    { value: "386", label: "Physical therapist" },
    { value: "387", label: "Physician assistant" },
    { value: "388", label: "Physician or Doctor" },
    { value: "389", label: "Physicist" },
    { value: "390", label: "Pile-driver operator" },
    { value: "391", label: "Plasterer or stucco mason" },
    { value: "392", label: "Plumber, Pipefitter, and Steamfitter" },
    { value: "393", label: "Podiatrist" },
    { value: "394", label: "Police officer" },
    { value: "395", label: "Postal service mail carrier" },
    { value: "396", label: "Postal service office worker" },
    { value: "397", label: "Postmaster and mail superintendent" },
    { value: "398", label: "Power plant operator or worker" },
    { value: "399", label: "Precision instrument repairer" },
    { value: "400", label: "Printing press operator or worker" },
    { value: "401", label: "Prison Guard" },
    { value: "402", label: "Private detective and investigator" },
    { value: "403", label: "Probation officer" },
    { value: "404", label: "Producer or director" },
    { value: "405", label: "Production worker" },
    { value: "406", label: "Professor" },
    { value: "407", label: "Prosthodontist" },
    { value: "408", label: "Psychiatric aide" },
    { value: "409", label: "Psychiatric technician" },
    { value: "410", label: "Psychiatrist" },
    { value: "411", label: "Psychologist" },
    { value: "412", label: "Public Announcer" },
    { value: "413", label: "Public relations specialist" },
    { value: "414", label: "Pumping station operator" },
    { value: "415", label: "Purchasing Agent" },
    { value: "416", label: "Radiation therapist" },
    { value: "417", label: "Radio and communications installer" },
    { value: "418", label: "Radio operator" },
    { value: "419", label: "Radio or television announcer" },
    { value: "420", label: "Radio, cellular, and tower equipment" },
    { value: "421", label: "Rail car repairer" },
    { value: "422", label: "Railroad conductor and yardmaster" },
    { value: "423", label: "Railroad Worker" },
    { value: "424", label: "Rail-track layer or maintenance opr" },
    { value: "425", label: "Real estate broker and Agent" },
    { value: "427", label: "Receptionist" },
    { value: "428", label: "Recreation and fitness worker" },
    { value: "429", label: "Recreational vehicle service technician" },
    { value: "430", label: "Registered nurse" },
    { value: "431", label: "Rehabilitation Counselor" },
    { value: "432", label: "Reinforcing iron and rebar worker" },
    { value: "433", label: "Religious worker" },
    { value: "434", label: "Rendering Plant Worker" },
    { value: "435", label: "Reporter, journalist, or correspondent" },
    { value: "436", label: "Respiratory therapist" },
    { value: "437", label: "Retail sales worker" },
    { value: "439", label: "Rigger" },
    { value: "440", label: "Rock splitter, quarry" },
    { value: "441", label: "Roofer" },
    { value: "442", label: "Roustabout, oil and gas" },
    { value: "443", label: "Sales representative, service, all other" },
    { value: "444", label: "Scuba or Snorkle Instructor" },
    { value: "445", label: "Secretary or administrative assistant" },
    { value: "446", label: "Security and fire alarm systems installer" },
    { value: "447", label: "Security guard" },
    { value: "448", label: "Septic tank svc or sewer pipe cleaner" },
    { value: "449", label: "Set and exhibit designer" },
    { value: "450", label: "Sewing machine operator" },
    { value: "451", label: "Sheet metal worker" },
    { value: "452", label: "Ship and boat captain and operator" },
    { value: "453", label: "Shoe and leather repair or worker" },
    { value: "454", label: "Signal and track switch repairer" },
    { value: "455", label: "Slaughterer and meat packer" },
    { value: "456", label: "Small engine mechanic" },
    { value: "457", label: "Social worker" },
    { value: "458", label: "Sociologist" },
    { value: "459", label: "Software developer and programmer" },
    { value: "460", label: "Solar panel installer" },
    { value: "461", label: "Sonographer" },
    { value: "462", label: "Sound engineering technician" },
    { value: "463", label: "Speech-language pathologist" },
    { value: "464", label: "Sports Scout" },
    { value: "465", label: "Sprinkler installer" },
    { value: "466", label: "Statistician" },
    { value: "467", label: "Stockbroker" },
    { value: "468", label: "Structural iron and steel worker" },
    { value: "470", label: "Substance abuse or Behavior Counselor" },
    { value: "471", label: "Substitute teacher" },
    { value: "472", label: "Subway and streetcar opr or conductor" },
    { value: "473", label: "Surgeon" },
    { value: "474", label: "Surveyor" },
    { value: "475", label: "Switchboard operator" },
    { value: "476", label: "Systems analyst" },
    { value: "477", label: "Tailor, dressmaker, or Seamstress" },
    { value: "478", label: "Tank, car, truck, and ship loader" },
    { value: "479", label: "Taper" },
    { value: "480", label: "Tax examiner" },
    { value: "481", label: "Tax preparer" },
    { value: "482", label: "Taxi driver or chauffeur" },
    { value: "483", label: "Teacher assistant" },
    { value: "484", label: "Teacher or instructor" },
    { value: "485", label: "Technical Writer" },
    { value: "486", label: "Telemarketer" },
    { value: "487", label: "Telephone operator" },
    { value: "488", label: "Teller or Bank worker" },
    { value: "489", label: "Textile, apparel" },
    { value: "490", label: "Therapist" },
    { value: "491", label: "Tire repairer and changer" },
    { value: "492", label: "Title examiner, abstractor, and searcher" },
    { value: "493", label: "Tobacco machine operator and tender" },
    { value: "494", label: "Toll Collector" },
    { value: "495", label: "Tool and die maker" },
    { value: "496", label: "Tool grinder, filer, and sharpener" },
    { value: "497", label: "Tour and travel guide" },
    { value: "498", label: "Tow Truck Driver" },
    { value: "499", label: "Transit and railroad police" },
    { value: "500", label: "Transportation security worker (TSA)" },
    { value: "501", label: "Travel Agent" },
    { value: "502", label: "Tree trimmers and pruner" },
    { value: "503", label: "Truck Driver, Local, Beverage Delivery" },
    { value: "504", label: "Truck Driver, Local, Light Delivery" },
    { value: "505", label: "Truck Driver, Long Haul Over the Road" },
    { value: "506", label: "Underground Construction Worker" },
    { value: "507", label: "Unskilled Health Care Aide" },
    { value: "508", label: "Upholsterer" },
    { value: "509", label: "Urban and regional planner" },
    { value: "510", label: "Usher, lobby attendant, and ticket taker" },
    { value: "511", label: "USPS, UPS, FedEx, Delivery Driver" },
    { value: "512", label: "Valet" },
    { value: "513", label: "Veterinarian - Large Animal or Mixed" },
    { value: "514", label: "Veterinarian - Small Animal" },
    { value: "515", label: "Veterinary assistant" },
    { value: "516", label: "Waiter or waitress" },
    { value: "517", label: "Warden, Fish and Game" },
    { value: "518", label: "Warden, Prison" },
    { value: "519", label: "Warehouse worker" },
    { value: "520", label: "Waste Management Route Worker" },
    { value: "521", label: "Waste Management Truck Driver" },
    { value: "522", label: "Watch repairer" },
    { value: "523", label: "Water or wastewater treatment worker" },
    { value: "524", label: "Web developer" },
    { value: "525", label: "Welder, cutter, solderer, and brazer" },
    { value: "526", label: "Wellhead pumper" },
    { value: "527", label: "Wild Animal Trainer" },
    { value: "528", label: "Wind turbine service technician" },
    { value: "530", label: "Window washer, Commercial" },
    { value: "531", label: "Window washer, Residential" },
    { value: "532", label: "Woodworker" },
    { value: "534", label: "Zoologist and wildlife biologist" },
    { value: "535", label: "Owner" },
    { value: "537", label: "Advertising worker" },
    { value: "538", label: "Business Agent" },
    { value: "539", label: "Cafe Worker" },
    { value: "540", label: "Dance Instructor" },
    { value: "541", label: "Entertainment Industry worker" },
    { value: "542", label: "Dog Groomer" },
    { value: "543", label: "Freight Handler" },
    { value: "544", label: "Golf Course worker" },
    { value: "545", label: "Government Employee" },
    { value: "546", label: "Grocery Store worker" },
    { value: "547", label: "Nursing Home worker" },
    { value: "548", label: "Jockey" },
    { value: "549", label: "Laborer, unskilled" },
    { value: "550", label: "Lecturer" },
    { value: "551", label: "Lumber yard worker" },
    { value: "552", label: "Manufacturing worker" },
    { value: "553", label: "Repairer" },
    { value: "555", label: "Restaurant manager" },
    { value: "556", label: "Route Driver" },
    { value: "557", label: "Siding Installer" },
    { value: "558", label: "Animal Care" },
    { value: "559", label: "Stocker" },
    { value: "560", label: "Street Cleaner" },
    { value: "561", label: "Wallpaperer" },
    { value: "562", label: "Zoo Employee" },
    { value: "563", label: "Office worker" },
    { value: "564", label: "Auctioneer" },
    { value: "565", label: "Air Hammer Operator" },
  ];

  return occupationList.sort((a, b) => (a.label > b.label) ? 1 : ((a.label < b.label) ? -1 : 0));
}



// WEBPACK FOOTER //
// ./src/components/Quoters/AmericoLoanProtection/Helpers/Occupations.js